import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render({ content }) {
        if (content) {
            return (
                <raw dangerouslySetInnerHTML={{__html: content}} />
            );
        }

        return (<raw />);
    }
}

export default connect()(Component);



// WEBPACK FOOTER //
// ./app/components/raw.js